export const FEATURE_NAME = 'UtilsChest';
